// extracted by mini-css-extract-plugin
export var currencyInput = "_nq-1";
export var currencySymbol = "_nq-0";